import api from '../../api';
import { TPunterStatement } from './statements.types';

export const punterStatements = '/punter/statements';

export const queryPunterStatements = () =>
  api.get<TPunterStatement[]>(punterStatements).then((res) => res.data);
